@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.invoices.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.invoices.generated.resources/"

internal val Res.string.feature_invoices_amount: StringResource by lazy {
      StringResource("string:feature_invoices_amount", "feature_invoices_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 39),
      ))
    }

internal val Res.string.feature_invoices_consumer_id: StringResource by lazy {
      StringResource("string:feature_invoices_consumer_id", "feature_invoices_consumer_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50, 56),
      ))
    }

internal val Res.string.feature_invoices_date: StringResource by lazy {
      StringResource("string:feature_invoices_date", "feature_invoices_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 37),
      ))
    }

internal val Res.string.feature_invoices_error_no_invoices_found: StringResource by lazy {
      StringResource("string:feature_invoices_error_no_invoices_found", "feature_invoices_error_no_invoices_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145, 112),
      ))
    }

internal val Res.string.feature_invoices_error_oops: StringResource by lazy {
      StringResource("string:feature_invoices_error_oops", "feature_invoices_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258, 43),
      ))
    }

internal val Res.string.feature_invoices_invoice: StringResource by lazy {
      StringResource("string:feature_invoices_invoice", "feature_invoices_invoice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 363, 44),
      ))
    }

internal val Res.string.feature_invoices_invoice_details: StringResource by lazy {
      StringResource("string:feature_invoices_invoice_details", "feature_invoices_invoice_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302, 60),
      ))
    }

internal val Res.string.feature_invoices_items_bought: StringResource by lazy {
      StringResource("string:feature_invoices_items_bought", "feature_invoices_items_bought", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 408, 53),
      ))
    }

internal val Res.string.feature_invoices_loading: StringResource by lazy {
      StringResource("string:feature_invoices_loading", "feature_invoices_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 462, 44),
      ))
    }

internal val Res.string.feature_invoices_merchant_id: StringResource by lazy {
      StringResource("string:feature_invoices_merchant_id", "feature_invoices_merchant_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 52),
      ))
    }

internal val Res.string.feature_invoices_payment_options_will_be_fetched_from_upi: StringResource by
    lazy {
      StringResource("string:feature_invoices_payment_options_will_be_fetched_from_upi", "feature_invoices_payment_options_will_be_fetched_from_upi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 560, 141),
      ))
    }

internal val Res.string.feature_invoices_status: StringResource by lazy {
      StringResource("string:feature_invoices_status", "feature_invoices_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 702, 39),
      ))
    }

internal val Res.string.feature_invoices_transaction_id: StringResource by lazy {
      StringResource("string:feature_invoices_transaction_id", "feature_invoices_transaction_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 742, 63),
      ))
    }

internal val Res.string.feature_invoices_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_invoices_unexpected_error_subtitle", "feature_invoices_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 114),
      ))
    }

internal val Res.string.feature_invoices_unique_payment_link: StringResource by lazy {
      StringResource("string:feature_invoices_unique_payment_link", "feature_invoices_unique_payment_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 921, 72),
      ))
    }

internal val Res.string.feature_invoices_unique_receipt_link: StringResource by lazy {
      StringResource("string:feature_invoices_unique_receipt_link", "feature_invoices_unique_receipt_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 994, 76),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_invoices_amount", Res.string.feature_invoices_amount)
  map.put("feature_invoices_consumer_id", Res.string.feature_invoices_consumer_id)
  map.put("feature_invoices_date", Res.string.feature_invoices_date)
  map.put("feature_invoices_error_no_invoices_found", Res.string.feature_invoices_error_no_invoices_found)
  map.put("feature_invoices_error_oops", Res.string.feature_invoices_error_oops)
  map.put("feature_invoices_invoice", Res.string.feature_invoices_invoice)
  map.put("feature_invoices_invoice_details", Res.string.feature_invoices_invoice_details)
  map.put("feature_invoices_items_bought", Res.string.feature_invoices_items_bought)
  map.put("feature_invoices_loading", Res.string.feature_invoices_loading)
  map.put("feature_invoices_merchant_id", Res.string.feature_invoices_merchant_id)
  map.put("feature_invoices_payment_options_will_be_fetched_from_upi", Res.string.feature_invoices_payment_options_will_be_fetched_from_upi)
  map.put("feature_invoices_status", Res.string.feature_invoices_status)
  map.put("feature_invoices_transaction_id", Res.string.feature_invoices_transaction_id)
  map.put("feature_invoices_unexpected_error_subtitle", Res.string.feature_invoices_unexpected_error_subtitle)
  map.put("feature_invoices_unique_payment_link", Res.string.feature_invoices_unique_payment_link)
  map.put("feature_invoices_unique_receipt_link", Res.string.feature_invoices_unique_receipt_link)
}
